import Type from '../../../type';

export function fetchInlineScripts(acc: Array<string>, item: { JS: string; isInternal: boolean }): Array<string>
{
	if (item.isInternal)
	{
		acc.push(item.JS);
	}

	return acc;
}

export function fetchExternalScripts(acc: Array<string>, item: { JS: string; isInternal: boolean }): Array<string>
{
	if (!item.isInternal)
	{
		acc.push(item.JS);
	}

	return acc;
}

export function fetchExternalStyles(acc: Array<string>, item: string | null | undefined): Array<string>
{
	if (Type.isString(item) && item !== '')
	{
		acc.push(item);
	}

	return acc;
}

// Registers already-present assets as loaded so a later BX.load skips them.
// Legacy parity: CJSCore emitted BX.setJSList/BX.setCSSList for the files bundled
// inside core.js right after core.js, keeping a direct BX.load from re-executing
// the embedded core_ajax.js, polyfills, etc.
// setJSList/setCSSList exist only in the full core.js: in a minimal-bundle
// environment the pre-load registration is silently skipped, and the post-load
// call registers the URLs against the API provided by the freshly loaded core.
export function registerAssetsAsLoaded(js: Array<string>, css: Array<string>): void
{
	if (Type.isArrayFilled(js) && Type.isFunction((BX as any).setJSList))
	{
		// eslint-disable-next-line @bitrix24/bitrix24-rules/no-bx
		BX.setJSList(js);
	}

	if (Type.isArrayFilled(css) && Type.isFunction((BX as any).setCSSList))
	{
		// eslint-disable-next-line @bitrix24/bitrix24-rules/no-bx
		BX.setCSSList(css);
	}
}

export function loadAll(items: Array<string>): Promise<void>
{
	const itemsList = Type.isArray(items) ? items : [items];

	if (itemsList.length === 0)
	{
		return Promise.resolve();
	}

	return new Promise((resolve, reject) => {
		// eslint-disable-next-line @bitrix24/bitrix24-rules/no-bx
		BX.load(itemsList, resolve, document, reject);
	});
}
